/* ══════════════════════════════════════
   JilbabCo — How-To Blog Template JS
══════════════════════════════════════ */
(function () {
  'use strict';

  /* Scroll-reveal */
  var reveals = document.querySelectorAll('.jcb-reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Estimated read time */
  var body = document.querySelector('.jcb-body');
  var readEl = document.getElementById('jcb-read-time');
  if (body && readEl) {
    var words = (body.textContent || '').split(/\s+/).length;
    var mins = Math.max(1, Math.round(words / 220));
    readEl.textContent = mins + ' min read';
  }
})();
